import React, { useEffect, useState } from "react";
import PostItem from "./PostItem";
import axios from 'axios';
import { BASE_URL } from './../contexts/UserContext';
import Loader from './Loader/Loader';


const Posts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const getAllPosts = async () => {
      try {
        const { data } = await axios.get(`${BASE_URL}/posts`);
        setPosts(data.posts);
      } catch (error) {
        console.log(error);
      }finally{
        setLoading(false);
      }
    }
    getAllPosts();
  }, [])




  return (
    loading ? (
      <Loader />
    ) : (
      <section className="posts">
        {posts.length > 0 ? (
          <div className="container posts__container">
            {posts.map((post) => (
              <PostItem key={post._id} post={post} />
            ))}
          </div>
        ) : (
          <div className="container center">
            <h2>No posts yet</h2>
          </div>
        )}
      </section>
    )
  );
};

export default Posts;
